import { FormControlWrapper } from "components/Wrappers/FormComponentsWrappers/FormControlWrapper";
import dayjs from "configs/dayjs.config";

const { DatePicker } = require("@mui/x-date-pickers");
const style = {
  width: "100%",
  marginTop: 16,
  marginBottom: 16,
};
export const DatePickerWrapper = ({ ...props }) => {
  const today = dayjs();
  return (
    <FormControlWrapper fullWidth>
      <DatePicker
        style={style}
        // TODO
        // minDate={today}
        {...props}
        format="DD-MM-YYYY"
      />
    </FormControlWrapper>
  );
};
